import { Font, Page, Text, View, Document, Image, StyleSheet, Link } from "@react-pdf/renderer";

Font.register({
    family: "Fira Sans",
    fonts: [
        { src: "/fonts/firasans-light.ttf", fontWeight: 300 },
        { src: "/fonts/firasans-medium.ttf", fontWeight: 500 },
    ],
});

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        marginVertical: 5,
    },
    totalcontainer: {
        borderTop: 1,
        flexDirection: "row",
        marginVertical: 5,
        paddingTop: 4,
    },
    containerBorder: {
        flexDirection: "row",
        borderBottom: 1,
        paddingBottom: 4,
        paddingTop: 6,
    },
    spacer: { marginVertical: 18 },
    section75: { width: "75%" },
    section25: { width: "25%" },
    section50: { width: "50%" },
    section30: { width: "30%" },
    section66: { width: "66%" },
    section15: { width: "15%" },
    body: {
        paddingTop: 25,
        paddingBottom: 20,
        paddingHorizontal: 75,
    },
    headerBody: {
        paddingTop: 25,
        paddingBottom: 20,
        paddingHorizontal: 35,
    },
    title: {
        fontSize: 14,
        textAlign: "left",
        fontFamily: "Fira Sans",
        textTransform: "uppercase",
        fontWeight: 500,
        marginTop: 20,
        marginBottom: 30,
    },
    text: {
        fontSize: 9,
        textAlign: "justify",
        fontFamily: "Fira Sans",
    },
     priceText: {		//campo anadido para alinear precios a la derecha
        fontSize: 9,
        textAlign: "right", 
        fontFamily: "Fira Sans",
    },
    boldtext: {
        fontSize: 9,
        textAlign: "left",
        fontWeight: 500,
        fontFamily: "Fira Sans",
    },
    boldPriceText: {
	fontSize: 9,
	textAlign: "right",
	fontWeight: 500,
	fontFamily: "Fira Sans",
    },
    endtext: {
        fontSize: 10.5,
        textAlign: "justify",
        fontFamily: "Fira Sans",
    },
    endtitle: {
        fontSize: 10.5,
        textAlign: "left",
        fontWeight: 500,
        fontFamily: "Fira Sans",
        marginBottom: 5,
        textDecoration: "underline",
    },
    endspacer: { marginVertical: 8 },
    headerimage: {
        marginLeft: 75,
        marginRight: 75,
        marginBottom: 50,
    },
    header: {
        fontSize: 12,
        marginBottom: 20,
        textAlign: "center",
        color: "grey",
    },
    pageNumber: {
        fontFamily: "Fira Sans",
        position: "absolute",
        textAlign: "center",
        fontSize: 8,
        bottom: 12,
        left: 0,
        right: 0,
    },
});

export default function MyDocument({ data, image }) {
    const date = new Date();

    function SpanishMonth() {
        const month = date.getMonth();

        switch (month) {
            case 0:
                return "Enero";
            case 1:
                return "Febrero";
            case 2:
                return "Marzo";
            case 3:
                return "Abril";
            case 4:
                return "Mayo";
            case 5:
                return "Junio";
            case 6:
                return "Julio";
            case 7:
                return "Agosto";
            case 8:
                return "Septiembre";
            case 9:
                return "Octubre";
            case 10:
                return "Noviembre";
            case 11:
                return "Diciembre";
        }
    }

    return (
        <Document>
            <Page style={styles.headerBody}>
                <Image style={styles.headerimage} src="/images/logo.png" />
                <View style={styles.spacer}></View>
                <View style={styles.spacer}></View>
                <Image src={image} />
                <View style={styles.pageNumber}>
                    <Text>
                        THEROOM2030 SL · CIF B01727015 · La Curtidora C/ Gutierrez Herero 52 · 33402 · AVILES - ASTURIAS
                    </Text>
                    <Text>T (+34) 984 29 05 71 · INFO@ROOM2030.COM · WWW.ROOM2030.COM</Text>
                </View>
            </Page>
            <Page style={styles.body}>
                <Text style={styles.title}>PRESUPUESTO ORIENTATIVO VIVIENDA UNIFAMILIAR {data.info[0][1]} </Text>
                <Text style={styles.text}>
                    Fecha: {date.getDate()} de {SpanishMonth()} de {date.getFullYear()}
                </Text>
                <View style={styles.spacer}></View>
                <Text style={styles.text}>PROPUESTA TIPOLOGÍA VIVIENDA UNIFAMILIAR</Text>
                <View style={styles.container}>
                    <View style={styles.section75}>
                        <Text style={styles.boldtext}>PLAZO DE ENTREGA 14 SEMANAS A PARTIR DE OBTENCIÓN LICENCIA</Text>
                    </View>
                    <View style={styles.section25}>
                        <Text style={styles.text}>THEROOM2030, SL</Text>
                        <Text style={styles.text}>CIF: B01727015</Text>
                        <Text style={styles.text}>C/Gutiérrez Herrero 52</Text>
                        <Text style={styles.text}>33402 Avilés</Text>
                    </View>
                </View>
                <View style={styles.spacer}></View>
                <View style={styles.containerBorder}>
                    <View style={styles.section30}>
                        <Text style={styles.text}>Elemento</Text>
                    </View>
                    <View style={styles.section25}>
                        <Text style={styles.text}>Opción</Text>
                    </View>
                    <View style={styles.section15}>
                        <Text style={styles.priceText}>Precio</Text>
                    </View>
                </View>
                {data.info.map(function (object, index) {
                    return data.info[index][0] != "Acento" ? (
                        <View style={styles.container}>
                            <View style={styles.section30}>
                                <Text style={styles.text}>{data.info[index][0]}</Text>
                            </View>
                            <View style={styles.section25}>
                                <Text style={styles.text}>{data.info[index][1]}</Text>
                            </View>
                            <View style={styles.section15}>
                                <Text style={styles.priceText}>{data.info[index][2]}€</Text>
                            </View>
                        </View>
                    ) : data.info[index][1] != "Ninguno" ? (
                        <View style={styles.container}>
                            <View style={styles.section30}>
                                <Text style={styles.text}>Acento</Text>
                            </View>
                            <View style={styles.section25}>
                                <Text style={styles.text}>{data.info[index][1]}</Text>
                            </View>
                            <View style={styles.section15}>
                                <Text style={styles.priceText}>{data.info[index][2]}€</Text>
                            </View>
                        </View>
                    ) : (
                        <View></View>
                    );
                })}
                {data.extras.map(function (object, index) {
                    return (
                        <View style={styles.container}>
                            <View style={styles.section30}>
                                <Text style={styles.text}>Extra</Text>
                            </View>
                            <View style={styles.section25}>
                                <Text style={styles.text}>{data.extras[index][0]}</Text>
                            </View>
                            <View style={styles.section15}>
                                <Text style={styles.priceText}>{data.extras[index][1]}€</Text>
                            </View>
                        </View>
                    );
                })}
                <View style={styles.totalcontainer}>
                    <View style={styles.section30}>
                        <Text style={styles.boldtext}>TOTAL</Text>
                    </View>
                    <View style={styles.section25}>
                    </View>
                    <View style={styles.section15}>
                        <Text style={styles.boldPriceText}>{data.total}€</Text>
                    </View>
                </View>
                <View style={styles.spacer}></View>
                <Text style={styles.text}>
                    Observaciones: Presupuesto orientativo de vivienda modular estandarizada en base a la selección de
                    opciones en el configurador web, no vinculante. No se incluye proyecto básico, ejecución, dirección
                    de obra, transporte, montaje y obra civil; sujetos al análisis detallado de la parcela. Aspecto
                    final e importe sujeto a variabilidad de materiales y modificaciones necesarias según ubicación
                    final.
                </Text>
            </Page>
            <Page style={styles.body}>
                <Image style={styles.headerimage} src="/images/logo.png" />
                <Text style={styles.endtitle}>Diseño</Text>
                <Text style={styles.endtext}>
                    El diseño del hábitat Room2030 contenido en esta propuesta es propiedad de Sergio Baragaño Cachón,
                    CEO de Room2030 SL, según la normativa aplicable de protección de diseño arquitectónico e
                    industrial, por lo tanto, no se puede difundirlo, revelarlo o transmitirlo a terceras personas
                    ajenas a la misma, salvo autorización expresa del mismo. Internamente solo podrá ser difundido,
                    revelado o trasmitido en el contexto del proceso de contratación de la mencionada propuesta.
                </Text>
                <View style={styles.endspacer}></View>
                <Text style={styles.endtitle}>Observaciones</Text>
                <Text style={styles.endtext}>- IVA no Incluido</Text>
                <Text style={styles.endtext}>
                    - La obtención de un presupuesto más preciso requiere el desarrollo de un estudio detallado de la
                    ubicación y condiciones del terreno y la accesibilidad del mismo.
                </Text>
                <Text style={styles.endtext}>
                    - Los requerimientos normativos locales pueden tener impacto en el diseño final del proyecto.
                </Text>
                <View style={styles.endspacer}></View>
                <Text style={styles.endtitle}>Validez Oferta</Text>
                <Text style={styles.endtext}>4 semanas</Text>
                <View style={styles.endspacer}></View>
                <Text style={styles.endtitle}>Política de Protección de Datos ROOM2023</Text>
                <Text style={styles.endtext}>Datos del responsable del tratamiento:</Text>
                <View style={styles.endspacer}></View>
                <Text style={styles.endtext}>Titular: THEROOM2030 SOCIEDAD LIMITADA - NIF: B01727015</Text>
                <Text style={styles.endtext}>
                    Domicilio social: GUTIERREZ HERRERO 52 – LA CURTIDORA. 33402. AVILES ESPAÑA
                </Text>
                <Text style={styles.endtext}>Teléfono: 984290571 - Correo electrónico: info@room2030.com </Text>
                <Text style={styles.endtext}>
                    Página web: <Link>https://www.room2030.com</Link>
                </Text>
                <View style={styles.endspacer}></View>
                <Text style={styles.endtext}>
                    “Los datos proporcionados serán tratados por THEROOM2030 SOCIEDAD LIMITADA con la finalidad de
                    realizar pedidos y gestionar la facturación de los productos y servicios contratados. Puede ejercer
                    sus derechos de acceso, rectificación, supresión y portabilidad de datos y oposición y limitación a
                    su tratamiento ante THEROOM2030 SOCIEDAD LIMITADA, GUTIERREZ HERRERO 52 – LA CURTIDORA. 33402.
                    AVILES (ESPAÑA) o en la dirección de correo electrónico info@room2030.com, adjuntando copia de su
                    DNI o documento equivalente. Puede ampliar esta información en relación con el tratamiento de sus
                    datos personales consultando nuestra Política de privacidad.”
                </Text>
                <View style={styles.pageNumber}>
                    <Text>
                        THEROOM2030 SL · CIF B01727015 · La Curtidora C/ Gutierrez Herero 52 · 33402 · AVILES - ASTURIAS
                    </Text>
                    <Text>T (+34) 984 29 05 71 · INFO@ROOM2030.COM · WWW.ROOM2030.COM</Text>
                </View>
            </Page>
        </Document>
    );
}
